

<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                
                <div class="row">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative" type="button">                                                
                                                <span>{{ $t('settings.New_user_manual') }}</span>                                                
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                        <div class="bg-white">
                                            <div class="row mt-4">
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.Type') }} *</label>
                                                        <select id="userManualTypeId" v-model="state.userManualTypeId" class="form-control form-control-default">
                                                            <option value="">{{ $t('settings.Select_referencetype') }}</option>
                                                            <option v-for="userManualType in state.userManualTypes" :key="userManualType.id" :value="userManualType.id">
                                                                {{ userManualType.name }}
                                                            </option>
                                                        </select>
                                                        <span v-if="v$.userManualTypeId.$error" class="text-sm text-danger">
                                                            {{ v$.userManualTypeId.$errors[0].$message }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-6" v-if="['Admin'].includes(userRoleName)">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.Association') }}</label>
                                                        <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                                                            <option value="">{{ $t('settings.Select_association') }}</option>
                                                            <option v-for="association in state.associations" :key="association.id" :value="association.id">
                                                                {{ association.abbreviation }}
                                                            </option>
                                                        </select>
                                                        <!--span v-if="v$.associationId.$error" class="text-sm text-danger">
                                                            {{ v$.associationId.$errors[0].$message }}
                                                        </span-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4">
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.Title') }} *</label>
                                                        <input v-model="state.title" type="text" class="form-control form-control-default" :placeholder="$t('settings.Title')">
                                                        <span v-if="v$.title.$error" class="text-sm text-danger">
                                                            {{ v$.title.$errors[0].$message }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4">
                                                <div class="col-12">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.Message') }} *</label>
                                                        <quill-editor
                                                        v-model="state.message"  
                                                        :options="editorOptions"
                                                        contentType="html"
                                                        theme="snow"
                                                        :placeholder="$t('settings.Message')"
                                                        ></quill-editor>
                                                        <span v-if="v$.message.$error" class="text-sm text-danger">
                                                            {{ v$.message.$errors[0].$message }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4">
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.StartDate') }}</label>
                                                        <input v-model="state.startDate" type="date" class="form-control form-control-default" :placeholder="$t('settings.StartDate')">                                                        
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label>{{ $t('settings.ExpiryDate') }}</label>
                                                        <input v-model="state.expiryDate" type="date" class="form-control form-control-default" :placeholder="$t('settings.ExpiryDate')">                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4">
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                    <label>{{ $t('user.Role') }}</label> 
                                                    <select id="roleName" v-model="state.roleName" class="form-control form-control-default">
                                                        <option value="">{{ $t('user.Select_role') }}</option>
                                                        <option v-for="role in state.roles" :key="role.id" :value="role.name">
                                                            {{ translatedRole(role.name) }}
                                                        </option>
                                                    </select>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.Active') }}</label>
                                                        <div class="d-block mt-1">
                                                            <material-switch v-model="state.isActive" id="isActive" name="isActive" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 mt-4">
                                            <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                                            <button v-on:click="saveForm" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Save') }}</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import * as Choices from "choices.js";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import useVuelidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { useStore } from 'vuex'
import { QuillEditor } from '@vueup/vue-quill'

    export default {
        name: 'UserManual_create_page',

        setup() {

            const { t } = useI18n()
            const store = useStore()

            const translatedRole = (name) => {
                return t(`roles.${name.toLowerCase()}`)
            }

            const state = reactive ({
                userManualTypeId: '',
                associationId: '',
                title: '',
                message: '',
                roleName: '',
                startDate: null,
                expiryDate: null,
                isActive: true,
                associations:[],
                userManualTypes:[],
                roles:[]
            })

            const userRoleName = computed(() => store.state.user?.roleName)
        
            function isNotEmptyValue(value) {
                if (value == null) return false

                // Handle Quill Delta (object with ops)
                if (typeof value === 'object' && Array.isArray(value.ops)) {
                    const text = value.ops
                    .map(op => (typeof op.insert === 'string' ? op.insert : ''))
                    .join('')
                    // remove zero-width and whitespace
                    return text.replace(/\u200B/g, '').trim().length > 0
                }

                // Otherwise treat as string (HTML)
                let s = String(value)

                // remove zero-width / invisible chars
                s = s.replace(/\u200B/g, '')

                // decode common HTML entities that create visible/non-visible space
                s = s.replace(/&nbsp;|&#160;|&zwnj;|&zwj;/g, ' ')

                // remove tags
                s = s.replace(/<(.|\n)*?>/g, '')

                // collapse whitespace & trim
                s = s.replace(/\s+/g, ' ').trim()

                return s.length > 0
            }


            const rules = computed(() => {
                //const isAdmin = userRoleName.value === 'Admin';

                return {
                    title: { required: helpers.withMessage(t('common.Required'), required) },
                    message: {
                        required: helpers.withMessage(
                        t('common.Required'),
                        value => isNotEmptyValue(value)
                        )
                    },
                    userManualTypeId: {
                        required: helpers.withMessage(t('common.Required'), required),
                        isSelected: helpers.withMessage(t('common.Select_an_usermanual_type'), value => value !== '')
                    },
                    //associationId: isAdmin
                    //? {
                    //    required: helpers.withMessage(t('common.Required'), required),
                    //    isSelected: helpers.withMessage(t('common.Select_an_association'), value => value !== '')
                    //}
                    //: {}
                }
            })
        
            const v$ = useVuelidate(rules, state)

             watch(() => state.message, () => {
                v$.value.message.$touch()
                v$.value.message.$validate()
            })

            const editorOptions = {
                theme: 'snow', // 'snow' or 'bubble'
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                        ['blockquote', 'code-block'],

                        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                        [{ 'direction': 'rtl' }],                         // text direction

                        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                        [{ 'font': [] }],
                        [{ 'align': [] }],

                        ['clean'],                                         // remove formatting button
                        ['link', 'image', 'video']                         // link and image, video
                    ]
                },
                placeholder: 'Compose an epic...',
            };
            
            return {
                state,
                v$,
                translatedRole,
                userRoleName,
                choicesInstanceAssociation: null,
                choicesInstanceUserManualType: null,
                choicesInstanceRole: null,
                editorOptions
            }
        },    
    components: {
        MaterialSwitch,
        QuillEditor
    },  
    async mounted() {
        this.$store.commit('setShowLoading', true);
        try { 
            await Promise.all([
                this.fetchAndPopulate({
                    url: "UserManualType/getall/",
                    listPath: "data",
                    stateKey: "userManualTypes",
                    selectId: "userManualTypeId",
                    instanceKey: "choicesInstanceUserManualType",
                    selectedValueGetter: () => this.state.userManualTypeId
                }),
                this.fetchAndPopulate({
                    url: this.userRoleName === 'Admin' ? "auth/getroles" : "auth/getassociationadminroles",
                    listPath: "data.roleList",
                    targetContainer: "formData",
                    stateKey: "roles",
                    formKey: "roles",
                    selectId: "roleName",
                    instanceKey: "choicesInstanceRole",
                    selectedValueGetter: () => this.state.roleName
                })
            ]);
            
            if (this.userRoleName === 'Admin') {
                await this.fetchAndPopulate({
                    url: "Association/getall",
                    listPath: "data.associationList",
                    stateKey: "associations",
                    selectId: "associationId",
                    instanceKey: "choicesInstanceAssociation",
                    selectedValueGetter: () => this.state.associationId
                });
            }
        } catch (e) {            
            console.error("mounted: unexpected error", e);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },      
    methods: {  
        async fetchAndPopulate({
            url,
            listPath = "data",
            targetContainer = "state",
            stateKey,
            formKey,
            selectId,
            instanceKey,
            selectedValueGetter = () => null
        }) {
            try {
                const response = await axios.get(url);
                const result = response.data;
                
                const arr = listPath.split('.').reduce((acc, p) => (acc && acc[p] !== undefined) ? acc[p] : null, result);

                if (!result.success || !Array.isArray(arr)) {
                    this.$showError(this.$t('errors.Error_fetching_data') || 'Error fetching data');
                    return;
                }

                if (targetContainer === "formData" && formKey) {
                    this.state[formKey] = arr;
                }

                if (stateKey) {
                    this.state[stateKey] = arr;
                }
                
                if (selectId && instanceKey) {
                    this.$nextTick(() => {
                        this.initializeChoicesDropdown({
                            id: selectId,
                            dataList: this.state[stateKey] || arr,
                            selectedValue: typeof selectedValueGetter === 'function' ? selectedValueGetter() : selectedValueGetter,
                            instanceKey
                        });
                    });
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },

        initializeChoicesDropdown({ id, dataList = [], selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
            console.error(`Choices: Invalid or missing select element with ID "${id}".`);
            return;
            }

            if (this[instanceKey] && typeof this[instanceKey].destroy === 'function') {
                try { 
                    this[instanceKey].destroy(); 
                } catch (err) { 
                    console.warn('Choices destroy failed', err); 
                }
            }

            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });
            
            const valueExists = (value) => {
                if (!value) return false;
                return dataList.some(item => {
                    const v = item?.id ?? item?.Id ?? item?.ID ?? item?.value ?? item?.Value;                
                    return String(v) === String(value);
                });
            };

            if (selectedValue) {
                const exists = valueExists(selectedValue);
                if (exists) {
                    try {
                        this[instanceKey].setChoiceByValue([String(selectedValue)]);
                    } catch (err) {
                        element.value = selectedValue;
                        element.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                } else {
                    try {
                        this[instanceKey].clearStore();
                    } catch (err) { 
                        /* ignore */ 
                    }
                }
            }
        },
    
        async fetchAllUsermanualTypeData() {
            return this.fetchAndPopulate({
                url: "UserManualType/getall/",
                listPath: "data",
                stateKey: "userManualTypes",
                selectId: "userManualTypeId",
                instanceKey: "choicesInstanceUserManualType",
                selectedValueGetter: () => this.state.userManualTypeId
            });
        },

        async fetchAllRoleData() {
            return this.fetchAndPopulate({
                url: this.userRoleName === 'Admin' ? "auth/getroles" : "auth/getassociationadminroles",
                listPath: "data.roleList",
                targetContainer: "formData",
                stateKey: "roles",
                formKey: "roles",
                selectId: "roleName",
                instanceKey: "choicesInstanceRole",
                selectedValueGetter: () => this.state.roleName
            });
        },

        async fetchAllAssociationData() {
            return this.fetchAndPopulate({
                url: "Association/getall",
                listPath: "data.associationList",
                stateKey: "associations",
                selectId: "associationId",
                instanceKey: "choicesInstanceAssociation",
                selectedValueGetter: () => this.state.associationId
            });
        },
    
        async saveForm() {
            this.submitForm();
        },           
        async submitForm() {
            try {
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    return;
                } 
                
                if(this.state.startDate === '') {
                    this.state.startDate = null;
                }
                if(this.state.expiryDate === '') {
                    this.state.expiryDate = null;
                }

                this.$store.commit('setShowLoading', true);

                const formData = {
                    userManualTypeId: this.state.userManualTypeId,
                    associationId: this.userRoleName === 'Admin'
                        ? this.state.associationId
                        : this.$store.state.associationAdminAssociationId,
                    title: this.state.title,
                    message: this.state.message,
                    roleName: this.state.roleName,
                    startDate: this.state.startDate,
                    expiryDate: this.state.expiryDate,
                    isActive: this.state.isActive
                };

                const response = await axios.post('UserManual/save', formData);
                this.gets = response.data;

                if (this.gets.success) {
                    this.$showSuccess('errors.Success_new_user_manual_added_successfully');
                    
                    this.$router.push('/settings');
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            }
            catch(e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>
<style scoped>  
    
    ::v-deep .ql-toolbar { width: 100%; }
    ::v-deep .ql-container {
        width: 100%;
        min-height: 220px !important;
    
    }    
    
</style>